import type { TrackContribution } from '@kangaroo/shared';

export type CircuitSetupStep = 0 | 1 | 2 | 3 | 4;

export function resolveCircuitSetupStep(input: {
  assigned: boolean;
  startFinishReady: boolean;
  lapCount: number;
  hasSavedLaps: boolean;
}): CircuitSetupStep {
  if (!input.assigned) return 0;
  if (!input.startFinishReady) return 1;
  if (input.lapCount === 0) return 2;
  if (!input.hasSavedLaps) return 3;
  return 4;
}

export function countAuthoredCircuitTurns(contribution: TrackContribution | null | undefined) {
  if (!contribution) return 0;

  const authoredBoundaries = contribution.payload.detailedGeometry?.features.filter(
    (feature) => (feature.entryLine?.length ?? 0) >= 2 && (feature.exitLine?.length ?? 0) >= 2,
  ).length;

  return authoredBoundaries
    ?? contribution.payload.cornerCount
    ?? contribution.payload.cornerApexSuggestions.length
    ?? 0;
}
